import { Navigate, RouteObject } from 'react-router-dom';
import { EvalLayout } from './components/layout/EvalLayout';
import { DatasetCreatePage } from './pages/datasets/DatasetCreatePage';
import { DatasetDetailPage } from './pages/datasets/DatasetDetailPage';
import { DatasetListPage } from './pages/datasets/DatasetListPage';
import { InferencePickerPage } from './pages/gt-inferences/InferencePickerPage';
import { GtSamplePage } from './pages/gt-samples/GtSamplePage';
import { GtSamplesListPage } from './pages/gt-samples/GtSamplesListPage';
import { MetricsPage } from './pages/metrics/MetricsPage';
import { ModelDetailPage } from './pages/models/ModelDetailPage';
import { PcConfigsListPage } from './pages/models/PcConfigsListPage';
import {
  OdModelListPage,
  OosModelListPage,
  PrModelListPage,
} from './pages/models/RayModelListPage';
import { CompareRunsPage } from './pages/runs/CompareRunsPage';
import { RunDetailPage } from './pages/runs/RunDetailPage';
import { RunInferenceSamplePage } from './pages/runs/RunInferenceSamplePage';
import { RunListPage } from './pages/runs/RunListPage';
import { RunSchedulerPage } from './pages/runs/RunSchedulerPage';
import { prCompRoutes } from './pr-compliance/routes';

export const evalRoutes: RouteObject = {
  path: '/eval',
  element: <EvalLayout />,
  children: [
    { index: true, element: <Navigate to="runs" replace /> },
    { path: 'runs', element: <RunListPage /> },
    { path: 'runs/new', element: <RunSchedulerPage /> },
    { path: 'runs/compare', element: <CompareRunsPage /> },
    { path: 'runs/:runId', element: <RunDetailPage /> },
    { path: 'runs/:runId/inferences/:runInferenceId', element: <RunInferenceSamplePage /> },
    { path: 'datasets', element: <DatasetListPage /> },
    { path: 'datasets/new', element: <DatasetCreatePage /> },
    { path: 'datasets/:datasetId', element: <DatasetDetailPage /> },
    { path: 'gt-samples', element: <GtSamplesListPage /> },
    { path: 'gt-samples/:gtSampleId', element: <GtSamplePage /> },
    { path: 'pr-inferences', element: <InferencePickerPage /> },
    { path: 'models', element: <Navigate to="/eval/od-models" replace /> },
    { path: 'od-models', element: <OdModelListPage /> },
    { path: 'pr-models', element: <PrModelListPage /> },
    { path: 'oos-models', element: <OosModelListPage /> },
    { path: 'models/:modelId', element: <ModelDetailPage /> },
    { path: 'pc-configs', element: <PcConfigsListPage /> },
    { path: 'metrics', element: <MetricsPage /> },
    ...prCompRoutes,
  ],
};
